import React from "react";
import "animate.css";

function Business() {
  return (
    <>
      {/* Header Start */}
      
      
       <div className="container-fluid bg-breadcrumb5">
        <div className="bg-breadcrumb-single" />
        <div className="container text-center py-5" style={{ maxWidth: 900 }}>
          <h4
            className="text-white display-4 mb-4 wow fadeInDown"
            data-wow-delay="0.1s"
          >
            Business Analytics 
          </h4>
        </div>
       </div>

      {/* Main Content Start */}
      <div className="container py-5">

        {/* Section 1: Business Analytics Solutions for Data-Driven Decisions */}
        <section className="wow fadeInUp" data-wow-delay="0.2s">
          <div className="row align-items-center mb-5">
            <div className="col-lg-6">
              <img
                src="assets/img/ba1.png"
                alt="Business Analytics"
                className="img-fluid rounded-4 shadow-lg"
              />
            </div>
            <div className="col-lg-6">
              <div className="section-title">
                <h2>Business Analytics Solutions for Data-Driven Decisions</h2>
                <p>
                  Celersoft can enable businesses to leverage <strong>AI and ML</strong> by delivering tailored solutions
                  for automation, predictive analytics, and data-driven decision-making.
                  With expertise in areas like natural language processing, computer vision, and
                  generative AI, they assist in developing and integrating models into existing systems.
                  From use-case identification to deployment and optimization, we can provide end-to-end
                  support to drive innovation and operational efficiency.
                </p>
                <p>
                  Unlock powerful insights and drive smarter decision-making with our{" "}
                  <strong>Business Analytics</strong> solutions. We specialize in
                  transforming raw data into actionable insights, enabling businesses to
                  make data-driven decisions that enhance efficiency, improve customer
                  experiences, and boost profitability. From data visualization to
                  advanced analytics, our services empower organizations to harness the
                  full potential of their data assets.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Section 2: Our Business Analytics Service Offerings */}
        {/* Section 2: Our Business Analytics Service Offerings */}
        <section className="wow fadeInUp" data-wow-delay="0.3s">
          <h3 className="mb-4 text-center">
            Our Business Analytics Service Offerings
          </h3>

          {/* Split layout for each offering with balanced, uniform images */}
          <div className="row align-items-center mb-5">
            <div className="col-lg-7">
              <h5>1. Data Strategy and Consulting</h5>
              <ul>
                <li>
                  Develop a customized data strategy aligned with your business goals,
                  designed to unlock valuable insights from your data.
                </li>
                <li>
                  Advisory services to identify key metrics, data sources, and analytics
                  tools that maximize ROI.
                </li>
              </ul>
            </div>
            <div className="col-lg-5 text-center">
              <img
                src="assets/img/ba2.jpg"
                alt="Data Strategy"
                className="img-fluid rounded-4 shadow"
                style={{ height: "300px", width: "100%", objectFit: "cover" }}
              />
            </div>
          </div>

          <div className="row align-items-center mb-5 flex-lg-row-reverse">
            <div className="col-lg-7">
              <h5>2. Data Warehousing and Management</h5>
              <ul>
                <li>
                  Design and implement secure, scalable data warehouses to centralize
                  data from multiple sources.
                </li>
                <li>
                  Data integration and quality management to ensure consistency and
                  reliability across your data assets.
                </li>
              </ul>
            </div>
            <div className="col-lg-5 text-center">
              <img
                src="assets/img/ba3.png"
                alt="Data Warehousing"
                className="img-fluid rounded-4 shadow"
                style={{ height: "300px", width: "100%", objectFit: "cover" }}
              />
            </div>
          </div>

          <div className="row align-items-center mb-5">
            <div className="col-lg-7">
              <h5>3. Business Intelligence (BI) and Visualization</h5>
              <ul>
                <li>
                  Leverage BI platforms like Power BI, Tableau, and others for
                  interactive dashboards and visualizations.
                </li>
                <li>
                  Real-time analytics and reporting to help stakeholders make informed
                  decisions quickly and confidently.
                </li>
              </ul>
            </div>
            <div className="col-lg-5 text-center">
              <img
                src="assets/img/ba4.jpg"
                alt="Business Intelligence"
                className="img-fluid rounded-4 shadow"
                style={{ height: "300px", width: "100%", objectFit: "cover" }}
              />
            </div>
          </div>

          <div className="row align-items-center mb-5 flex-lg-row-reverse">
            <div className="col-lg-7">
              <h5>4. Advanced Analytics and Predictive Modeling</h5>
              <ul>
                <li>
                  Apply advanced statistical techniques and machine learning models to
                  identify patterns and predict future trends.
                </li>
                <li>
                  Predictive analytics solutions tailored to optimize operations,
                  customer engagement, and risk management.
                </li>
              </ul>
            </div>
            <div className="col-lg-5 text-center">
              <img
                src="assets/img/ba5.jpg"
                alt="Predictive Analytics"
                className="img-fluid rounded-4 shadow"
                style={{ height: "300px", width: "100%", objectFit: "cover" }}
              />
            </div>
          </div>

          <div className="row align-items-center mb-5">
            <div className="col-lg-7">
              <h5>5. Big Data Analytics</h5>
              <ul>
                <li>
                  Scalable big data solutions that process large volumes of structured
                  and unstructured data.
                </li>
                <li>
                  Hadoop, Spark, and cloud-based big data services to uncover deep
                  insights from complex datasets.
                </li>
              </ul>
            </div>
            <div className="col-lg-5 text-center">
              <img
                src="assets/img/ba6.jpg"
                alt="Big Data"
                className="img-fluid rounded-4 shadow"
                style={{ height: "300px", width: "100%", objectFit: "cover" }}
              />
            </div>
          </div>

          <div className="row align-items-center mb-5 flex-lg-row-reverse">
            <div className="col-lg-7">
              <h5>6. Data Governance and Compliance</h5>
              <ul>
                <li>
                  Data governance frameworks to ensure your analytics practices meet
                  regulatory and compliance standards.
                </li>
                <li>
                  Data privacy and security measures to safeguard sensitive information
                  and build trust.
                </li>
              </ul>
            </div>
            <div className="col-lg-5 text-center">
              <img
                src="assets/img/ba7.png"
                alt="Data Governance"
                className="img-fluid rounded-4 shadow"
                style={{ height: "300px", width: "100%", objectFit: "cover" }}
              />
            </div>
          </div>

          <div className="row align-items-center mb-5">
            <div className="col-lg-7">
              <h5>7. Customer Analytics and Personalization</h5>
              <ul>
                <li>
                  Analyze customer behavior and preferences to deliver personalized
                  experiences.
                </li>
                <li>
                  Segmentation, churn prediction, and customer lifetime value (CLV)
                  analysis to enhance engagement and loyalty.
                </li>
              </ul>
            </div>
            <div className="col-lg-5 text-center">
              <img
                src="assets/img/ba8.png"
                alt="Customer Analytics"
                className="img-fluid rounded-4 shadow"
                style={{ height: "300px", width: "100%", objectFit: "cover" }}
              />
            </div>
          </div>
        </section>


        {/* Section 3: Why Choose Our Business Analytics Services (unchanged) */}
        <section className="wow fadeInUp" data-wow-delay="0.4s">
          <h3>Why Choose Our Business Analytics Services?</h3>
          <ul style={{ marginBottom: -30, padding: "0% 1% 1% 1" }}>
            <li style={{ lineHeight: 1.6 }}>
              <strong>Artificial Intelligence</strong>
            </li>
            <li style={{ lineHeight: 1.6 }}>
              <strong>Machine Learning</strong>
            </li>
            <li style={{ lineHeight: 1.6 }}>Business and Technology Consulting</li>
            <li style={{ lineHeight: 1.6 }}>Customer Operations Roadmap and Strategy</li>
            <li style={{ lineHeight: 1.6 }}>Package Evaluation</li>
            <li style={{ lineHeight: 1.6 }}>Implementation / Rollouts</li>
            <li style={{ lineHeight: 1.6 }}>Upgrades</li>
            <li style={{ lineHeight: 1.6 }}>Support and Maintenance</li>
            <li style={{ lineHeight: 1.6 }}>Computer Science</li>
            <li>
              <strong>Experienced Data Experts</strong>: Skilled data scientists
              and analysts who bring extensive industry expertise.
            </li>
            <li>
              <strong>Tailored Solutions</strong>: Customized analytics solutions
              that align with your unique business requirements and goals.
            </li>
            <li>
              <strong>Scalable and Secure</strong>: Analytics infrastructure that
              grows with your data needs, ensuring data privacy and compliance.
            </li>
          </ul>
        </section>
      </div>
       
      {/* Footer */}
      <div className="container-fluid footer wow fadeIn" data-wow-delay="0.2s">
        <div className="container pt-4">
          <div className="row g-5">
            <div className="col-md-6 col-lg-6 col-xl-3">
              <p><span style={{ fontSize: 20 }}><em><strong>USA</strong></em></span></p>
              <p><i className="fas fa-map-marker me-1" /> 1500 S Dairy Ashford Rd <br /> Ste 355 Houston, TX 77077</p>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <p><em><span style={{ fontSize: 20 }}><strong>CANADA</strong></span></em></p>
              <p><i className="fas fa-map-marker me-1" /> 998 Loft Court, London, Ontario, N6G0J9</p>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <p><span style={{ fontSize: 20 }}><em><strong>INDIA</strong></em></span></p>
              <p><i className="fas fa-map-marker me-1" /> D. No. 38, 2nd Floor, Arjun Plaza, SP Road, Nizampet, Hyderabad, Telangana - 500085</p>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <div className="footer-item d-flex flex-column">
                <a href="mailto:info@celersoft.com"><i className="fas fa-envelope me-2" /> info@celersoft.com</a>
                <a href="tel:+18322258898"><i className="fas fa-phone me-2" /> (+1) 832-225-8898</a>
                <hr />
                <div className="d-flex align-items-center">
                  <a className="btn btn-light btn-md-square me-2" href="https://www.facebook.com/celersoft">
                    <i className="fab fa-facebook-f" />
                  </a>
                  <a className="btn btn-light btn-md-square me-0" href="https://www.linkedin.com/company/celersoft/">
                    <i className="fab fa-linkedin-in" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="container-fluid copyright py-3">
        <div className="container">
          <div className="row g-4 align-items-center">
            <div className="col-md-6 text-center text-md-start mb-md-0">
              <span className="text-body">
                <i className="fas fa-copyright text-light me-1" />
                2024 Celersoft. All rights reserved.
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Back to Top Button */}
      <button
        className="btn btn-primary btn-lg-square back-to-top"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      >
        <i className="fa fa-arrow-up" />
      </button>
    </>

  );
}

export default Business;
